export const PLAN_META = {
  free: { label: "Free", color: "#6B7280", bgColor: "#F9FAFB", borderColor: "#E5E7EB" },
  start: { label: "Start", color: "#3B82F6", bgColor: "#EFF6FF", borderColor: "#BFDBFE" },
  pro: { label: "Pro", color: "#7321DF", bgColor: "#F5F0FF", borderColor: "#DDD2FF" },
  studio: { label: "Studio", color: "#D97706", bgColor: "#FFFBEB", borderColor: "#FDE68A" },
  business: { label: "Business", color: "#EA580C", bgColor: "#FFF7ED", borderColor: "#FED7AA" },
  enterprise: { label: "Enterprise", color: "#DC2626", bgColor: "#FEF2F2", borderColor: "#FECACA" },
};

// Um planOverride com prazo vencido some sozinho — não precisa de nada limpando o campo,
// getEffectivePlan já ignora e cai de volta pro plano real (mesma regra do backend).
export const isOverrideExpired = (person) =>
  Boolean(person?.planOverrideExpiresAt) && new Date(person.planOverrideExpiresAt).getTime() <= Date.now();

export const getEffectivePlan = (person) => {
  if (person?.planOverride && !isOverrideExpired(person)) return person.planOverride;
  // Assinatura inativa nunca deve contar o subscriptionPlan (pode estar cancelada/vencida
  // e o campo ficar com o último valor conhecido) — mesma regra do backend (normalizePlan).
  if (person?.subscription !== "active") return "free";
  const sp = (person?.subscriptionPlan || "").toLowerCase();
  if (sp.includes("enterprise")) return "enterprise";
  if (sp.includes("business")) return "business";
  if (sp.includes("studio")) return "studio";
  if (sp.includes("pro")) return "pro";
  if (sp.includes("start")) return "start";
  return "free";
};

// Rótulo curto pra mostrar embaixo do badge de plano na listagem/detalhe — deixa claro se o
// plano vem de assinatura real (RevenueCat/Kiwify) ou de um override manual, e até quando.
export const getPlanSourceLabel = (person) => {
  if (person?.planOverride && !isOverrideExpired(person)) {
    if (!person.planOverrideExpiresAt) return "Manual · sem prazo";
    const date = new Date(person.planOverrideExpiresAt);
    return `Manual · até ${date.toLocaleDateString("pt-BR")}`;
  }
  if (person?.planOverride && isOverrideExpired(person)) {
    return "Manual expirado";
  }
  return person?.subscription === "active" ? "Assinatura ativa" : "Sem assinatura";
};
